import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";
import stringifyParams from "@/utils/stringifyParams";

const useAssignmentGet = (id, queryParams = {}) => {
  let resource = `${MONOLITH_ORIGIN}/api/v3/assignment/${id}/`;
  const queryString = stringifyParams(queryParams);
  resource = `${resource}${queryString}`;
  return useRestQuery(resource, { skip: !id });
};

export default useAssignmentGet;
